import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material';
import { kpiband, kpiRelease, kpitarget, year, kpiViewHistory, kpi, kpiViewWorkFlow } from './../../../models/slakpi';
import { division } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { KPIInfoComponent } from './../../../component/slakpi/kpi-info/kpi-info.component';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { isNullOrUndefined } from 'util';
@Component({
  selector: 'app-kpi-release.component',
  templateUrl: './kpi-release.component.html',
  styleUrls: ['./kpi-release.component.css']

})
export class KPIReleaseComponent implements OnInit {
  //Global Variable
  modalRefBand: BsModalRef;
  modalTargetRef: BsModalRef;
  modalRef: BsModalRef;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  public sli_data: any;
  public kpiRelease_data: any;
  public kpiMapping_data: any;
  public kpiRelease_data_count: any;
  public kpiViewWorkflow_data: any;
  public kpiTargetHistory_data: any;
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public resettype_data: any;
  public slaUno?: number;
  public yearUno?: number;
  public quarterUno?: number;
  public divisionUno?: number;
  public frequencyUno?: number = 3;
  public selectedTab?: string = 'Release';
  public objkpiRelease: kpiRelease;
  public resetType_txt: string = '';
  public resetComment: string = '';
  public isResetType: boolean = false;
  public isResetTypeErr: boolean = false;
  public isCommentErr: boolean = false;
  public default_year: number = 2019;
  public kpiUnoSelected: number = 0;
  public kpiViewHistory_data: any;
  public kpiCodeDetail: kpi;
  public historyStartIndex: number = 1;
  public historyMaxCount: number = 50;
  public kpiRelease_data_count_WithoutTargetCount: number = 0;
  public kpiRelease_data_count_WithoutOwnerCount: number = 0;
  public kpiRelease_data_count_WithoutBandCount: number = 0;
  historydisableMore: boolean = true;
  isRowSelected: boolean = false;
  isFirstLoaded: boolean = false;


 
  @ViewChild('ResetDialog', { static: false }) ResetDialog: TemplateRef<any>;
  @ViewChild('KPIViewDialog', { static: false }) KPIViewDialog: TemplateRef<any>;
  @ViewChild('KPITargetUpdate', { static: false }) KPITargetUpdate: TemplateRef<any>;
  @ViewChild('KPIBandUpdate', { static: false }) KPIBandUpdate: TemplateRef<any>;
  //public selectionOptions: SelectionSettingsModel;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  //Load More
  public workflowStartIndex: number = 1;
  public workflowMaxCount: number = 300;
  workflowdisableMore: boolean = true;

  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  tenantUno?: number;
  isToggle: boolean = true;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  public permision_release: boolean = false;

  isAdmin: boolean = false;
  IsSlaAdmin: boolean = false;

  //for KPI All Hisory Dialog
  public kpinameSelected: string = '';
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
  public position_history: object = { X: 70, Y: 90 };
  public position_update: object = { X: 370, Y: 90 };

  //Target & Band Update
  public selected_schedule: number;
  public selected_kpiUno: number;
  public kpiTargetForm: FormGroup;
  public kpiBandForm: FormGroup;
  public yearsArray: FormArray;

  public selected_rule: any;
  public actualt_target: number;
  public actualt_target_full: number;
  public targetValue_Max: number;
  public scheduleTypeUno: number = 0;
  public kpiUno_global: number;
  public Frequency_global: number;
  public condition1_data: any;
  public condition2_data: any;
  public type_data: any;
    searchText: string;
  dataSearch: any = [];
  noDataImg: any;
  isDigitalDewa: boolean = false;
    slaName: any;
    
  constructor(public restApi: SLAKPIApiService, private modalService: BsModalService, public adminService: AdminApiService, private userService: UserService, private toaster: ToasterService,
    public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private kpiAllHistoryComponent: KPIInfoComponent, private formBuilder: FormBuilder) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly') ? true : false;
    this.IsSlaAdmin = (this.user.role == 'SLA Admin') ? true : false;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      this.permision_release = true;
    }

  }


  ngOnInit() {
    this.userService.CheckLogin();
    //default value settings
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.slaName = this.user.slaname;
    this.currentYear = Number(this.user.currentYear);
    this.currentHalf = Number(this.user.currentHalf);
    this.currentQuarter = Number(this.user.currentQuarter);
    this.currentMonth = this.user.currentMonth;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;
    
    this.gridOptions = {
      autoHeight: true,
      
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [ 100,200,300,400,500 ],
        pageSize: 500
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: true,
      
      
    
      checkboxSelector: {
        // optionally change the column index position of the icon (defaults to 0)
        // columnIndexPosition: 1,
        
        // remove the unnecessary "Select All" checkbox in header when in single selection mode
        hideSelectAllCheckbox: false,
        
        // you can override the logic for showing (or not) the expand icon
        // for example, display the expand icon only on every 2nd row
        selectableOverride: (row: number, data: any, grid: any) => (this.permision_release && data.rowType == 'Ready')
      
      },
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },

    };
    this.objkpiRelease = new kpiRelease();
    this.kpiRelease_data_count = new kpiRelease();
    this.kpiTargetForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
    this.kpiBandForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
    this.getConditions();
    this.getTypes();
    if (this.selectedTab == 'Release') {
      // this.loadKPIRelease(2); //All
      //this.loadKPIRelease_Count(2); //All
    }
    else if (this.selectedTab == 'Reset') {
      this.loadKPIRelease(4); //All
    }
    //Load Filter Vlaues
    this.loadFilterValues();
    this.loadFrequency();

    this.loadResetType();
    this.toolbar = ['Search'];
    this.kpiViewHistory_data = [];
    this.kpiCodeDetail = new kpi();
    this.pageSettings = { pageSize: 20, pageSizes: true };
    this.filterSettings = { type: 'Excel' };
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    //this.selectionOptions = { type: 'Multiple', checkboxOnly: true };
  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {
    //User rights
    let userPermissionData = this.userService.getUserRights("KPI  Release / Reset");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        let userPermissionDataRelease = this.userService.getUserRights("KPI Release");
        if (userPermissionDataRelease != null && userPermissionDataRelease != undefined && userPermissionDataRelease.length > 0) {
          if (userPermissionDataRelease[0].showPage == 1) {
            this.permision_release = true;
          }
          else
            this.permision_release = false;
        }

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          this.frequencyUno = 3;
          this.loadKPIRelease(2); //All
          this.loadKPIRelease_Count(2); //All
        }, 130);

        // this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  //Load Frequency Values
  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }
  //Load Reset Types
  loadResetType() {
    this.resettype_data = [
      { resettypeCode: 1, resettypeName: 'Draft' },
      { resettypeCode: 2, resettypeName: 'Data Collection' },
      { resettypeCode: 3, resettypeName: 'Approval - 1' },
      { resettypeCode: 4, resettypeName: 'Approval - 2' },
      { resettypeCode: 5, resettypeName: 'Approval - 3' }
    ];
  }

  // Get kpi release list
  loadKPIRelease(condition) {
    this.loading = true;
    this.kpiRelease_data_count_WithoutOwnerCount = 0;
    this.kpiRelease_data_count_WithoutTargetCount = 0;
    this.kpiRelease_data_count_WithoutBandCount = 0;
    this.spinner.show();
    let inpValue = new kpiRelease();
    inpValue.languageUno = 1033;
    inpValue.itemUno = (condition == 5) ? this.kpiUnoSelected : 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = (this.slaUno == undefined || this.slaUno == null) ? 0 : this.slaUno;//this.slaUno;
    inpValue.slayear = (this.yearUno == 0 || this.yearUno == undefined) ? this.currentYear : this.yearUno;
    inpValue.slaquarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? this.currentQuarter : this.quarterUno;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentMonth = this.currentMonth;
    inpValue.divisionUno = (this.divisionUno == undefined) ? 0 : this.divisionUno;//this.divisionUno;
    inpValue.frequencyUno = (this.frequencyUno == undefined) ? 0 : this.frequencyUno; //this.frequencyUno;
    this.kpiRelease_data = [];
    
    this.restApi.getKpiRelease(inpValue)
      .subscribe(data => {
        this.spinner.show();
        if (condition == 5) {
          this.kpiMapping_data = data;
         // setTimeout(() => { this.groupMappingOptions = { columns: ['year', 'quarter'] }; }, 100);
          this.isFirstLoaded = true;
        }
        else {
          this.kpiRelease_data = data;
          //this.groupOptions = { columns: ['slaNameEn'] };
        }
        const mockDataset = [];
        //for (let i = 0; i < this.kpiRelease_data.length; i++) {
        //  mockDataset[i] = {
        //    id: i + 1,
        //    scheduleUno: this.kpiRelease_data[i].scheduleUno,
        //    kpiName: this.kpiRelease_data[i].kpiName,
        //    kpiUno: this.kpiRelease_data[i].kpiUno,
        //    unitEn: this.kpiRelease_data[i].unitEn,
        //    kpiRule: this.kpiRelease_data[i].kpiRule,
        //    slaRuleUno: this.kpiRelease_data[i].slaRuleUno,
        //    targetValue: this.kpiRelease_data[i].targetValue,
        //    slaRuleName: this.kpiRelease_data[i].slaRuleName,
        //    dataOwnerName: this.kpiRelease_data[i].dataOwnerName,
        //    period: this.kpiRelease_data[i].period,
        //    slaNameEn: this.kpiRelease_data[i].slaNameEn,
        //    kpiNameEn: this.kpiRelease_data[i].kpiNameEn,
        //    kpiCode: this.kpiRelease_data[i].kpiCode,
        //    rowType: this.kpiRelease_data[i].rowType,
        //    dataOwnerActionByUno: this.kpiRelease_data[i].dataOwnerActionByUno,
        //    level1Approver: this.kpiRelease_data[i].level1Approver,
        //    level2Approver: this.kpiRelease_data[i].level2Approver,
        //    level3Approver: this.kpiRelease_data[i].level3Approver,
        //    bandValueExist: this.kpiRelease_data[i].bandValueExist,
        //  };
        //}
        
        this.dataSearch = [];
        this.dataset = [];
        setTimeout(() => {
          this.dataSearch = this.kpiRelease_data;//mockDataset;
          this.dataset = this.kpiRelease_data;//mockDataset;
          this.columnDefinitions = [];
          if (this.kpiRelease_data.length > 0) {
            this.setColnDefn();
          }
        }, 200);
        
        
        this.spinner.hide();
        this.kpiRelease_data_count_WithoutTargetCount = this.kpiRelease_data.filter(task => (task.rowType === 'T' || task.rowType === 'UT' || task.rowType === 'UTB' || task.rowType === 'TB')).length;
        this.kpiRelease_data_count_WithoutOwnerCount = this.kpiRelease_data.filter(task => (task.rowType === 'U' || task.rowType === 'UT' || task.rowType === 'UTB')).length;
        this.kpiRelease_data_count_WithoutBandCount = this.kpiRelease_data.filter(task => (task.rowType === 'B' || task.rowType === 'TB' || task.rowType === 'UTB' || task.rowType === 'TB')).length;
       
        setTimeout(() => {
          this.spinner.hide();
          this.loading = false;
        }, 1500);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.isFirstLoaded = true;
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //  this.spinner.hide();
        this.isFirstLoaded = true;
       // this.loading = false;
      });
  }
  //Load Kpi Count -- Release --To be Released --KPI Without Target / Band -- KPI Without Owner
  loadKPIRelease_Count(condition) {
    let inpValue = new kpiRelease();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = this.slaUno;
    inpValue.slayear = this.yearUno;//(this.yearUno == 0 || this.yearUno == undefined) ? this.currentYear : this.yearUno;
    inpValue.slaquarter = this.quarterUno; //(this.quarterUno == 0 || this.quarterUno == undefined) ? this.currentQuarter : this.quarterUno;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentMonth = this.currentMonth;
    inpValue.divisionUno = this.divisionUno;
    inpValue.frequencyUno = this.frequencyUno;
    this.restApi.getKpiReleaseCount(inpValue)
      .subscribe(data => {
        this.kpiRelease_data_count = data[0];
      },
        (error) => {

        }
      ).add(() => {

      });
  }
 
  handleSelectedRowsChanged1(e, args) {
    if (Array.isArray(args.rows) && this.angularGrid) {
      let selectedrecords = this.angularGrid.gridService.getSelectedRowsDataItem();
     
      this.objkpiRelease = new kpiRelease();
      for (let item of selectedrecords) {
        item = this.kpiRelease_data.filter(i => i.kpiUno == item.kpiUno)[0];
        if (item['level1Approver'] == null ||
          item['level1Approver'] == '' ||
          item['level2Approver'] == null ||
          item['level2Approver'] == '' ||
          item['level3Approver'] == null ||
          item['level3Approver'] == '' ||
          item['dataOwnerName'] == null ||
          item['dataOwnerName'] == '' ||
          ((item['slaRuleUno'] == "1" || item['slaRuleUno'] == "2") && (item['targetValue'] == '0' || item['bandValueExist'] == 0))
        ) {

        }
        else {
          let objKR = new kpiRelease();
          let objitem: any = item;
          objKR = objitem;
          objKR.tenantUno = this.tenantUno;
          
          this.objkpiRelease.dataOwnerUno = this.utilityService.isStringNull(item['dataOwnerUno']);
          this.objkpiRelease.dataOwnerActionByUno = this.utilityService.isNumericNull(item['dataOwnerActionByUno']);
          this.objkpiRelease.level1Approved = this.utilityService.isNumericNull(item['level1Approved']);
          this.objkpiRelease.level2Approved = this.utilityService.isNumericNull(item['level2Approved']);
          this.objkpiRelease.level3Approved = this.utilityService.isNumericNull(item['level3Approved']);
          objKR.dataOwnerUno = this.utilityService.isStringNull(item['dataOwnerUno']);
          //this.selectedData.push({ kpiUno: this.utilityService.isNumericNull(objitem.kpiUno) });
          this.objkpiRelease.objkpiRelease.push(objKR);
        }
      }
    }
    this.isRowSelected = (this.angularGrid.gridService.getSelectedRowsDataItem().length > 0) ? true : false;
    document.querySelectorAll(".ui-widget-content > .slick-cell-checkboxsel:not(.selected) >input").forEach(item => { item.parentElement.parentElement.classList.add('selectableRow') })


  }
  //rowSelecting(args: RowSelectingEventArgs) {

  //  //const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
  //  if (args.data['level1Approver'] == null ||
  //    args.data['level1Approver'] == '' ||
  //    args.data['level2Approver'] == null ||
  //    args.data['level2Approver'] == '' ||
  //    args.data['level3Approver'] == null ||
  //    args.data['level3Approver'] == '' ||
  //    args.data['dataOwnerName'] == null ||
  //    args.data['dataOwnerName'] == '' ||
  //    ((args.data['slaRuleUno'] == "1" || args.data['slaRuleUno'] == "2") && (args.data['targetValue'] == '0' || args.data['bandValueExist'] == 0))
  //  ) {
  //    // args.cancel = true;
  //  }

  //}
  //rowDataBound(args: RowDataBoundEventArgs) {
  //  
  //  if (args.data['level1Approver'] == null ||
  //    args.data['level1Approver'] == '' ||
  //    args.data['level2Approver'] == null ||
  //    args.data['level2Approver'] == '' ||
  //    args.data['level3Approver'] == null ||
  //    args.data['level3Approver'] == '' ||
  //    args.data['dataOwnerName'] == null ||
  //    args.data['dataOwnerName'] == '' ||
  //    ((args.data['slaRuleUno'] == "1" || args.data['slaRuleUno'] == "2") && (args.data['targetValue'] == '0' || args.data['bandValueExist'] == 0))
  //  ) {

  //    args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
  //    args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox');

  //    args.row.getElementsByClassName('e-rowcell')[0].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[1].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[2].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[3].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[4].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[5].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[6].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[7].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[8].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[9].classList.add('warninggridcolor');
  //    args.row.getElementsByClassName('e-rowcell')[10].classList.add('warninggridcolor');
  //  }

  //  if ((args.data['slaRuleUno'] == "1" || args.data['slaRuleUno'] == "2") && (args.data['targetValue'] == '0' || args.data['bandValueExist'] == '0')) {
  //    //this.kpiRelease_data_count_WithoutTargetCount += 1;
  //  }
  //  if (args.data['dataOwnerName'] == null || args.data['dataOwnerName'] == '') {
  //    //this.kpiRelease_data_count_WithoutOwnerCount += 1;
  //  }
  //}
  //rowDeSelected(args: RowDeselectEventArgs) {

  //  let objitem: any = args.data;

  //  for (let item of objitem) {

  //    let deleteItem: any = item;
  //    let index = this.objkpiRelease.objkpiRelease.findIndex(d => d.kpiUno === deleteItem.kpiUno); //find index in your array
  //    this.objkpiRelease.objkpiRelease.splice(index, 1);//remove element from array
  //  }
  //  this.isRowSelected = (this.grid.getSelectedRecords().length > 0) ? true : false;

  //}

  //rowSelected_Reset(args: RowSelectEventArgs) {

  //  //const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
  //  
  //  const selectedrecords: object[] = this.gridReset.getSelectedRecords();  // Get the selected records.
  //  this.objkpiRelease = new kpiRelease();
  //  this.isResetType = false;
  //  if (selectedrecords.length == 1) {
  //    this.isResetType = true;

  //  }

  //  for (let item of selectedrecords) {
  //    let objKR = new kpiRelease();
  //    let objitem: any = item;
  //    objKR = objitem;
  //    
  //    this.objkpiRelease.dataOwnerActionByUno = this.utilityService.isNumericNull(item['dataOwnerActionByUno']);
  //    this.objkpiRelease.level1Approved = this.utilityService.isNumericNull(item['level1Approved']);
  //    this.objkpiRelease.level2Approved = this.utilityService.isNumericNull(item['level2Approved']);
  //    this.objkpiRelease.level3Approved = this.utilityService.isNumericNull(item['level3Approved']);
  //    //this.selectedData.push({ kpiUno: this.utilityService.isNumericNull(objitem.kpiUno) });
  //    this.objkpiRelease.objkpiRelease.push(objKR);
  //  }
  //}
  //rowDeSelected_Reset(args: RowDeselectEventArgs) {

  //  let objitem: any = args.data;

  //  for (let item of objitem) {

  //    let deleteItem: any = item;
  //    let index = this.objkpiRelease.objkpiRelease.findIndex(d => d.kpiUno === deleteItem.kpiUno); //find index in your array
  //    this.objkpiRelease.objkpiRelease.splice(index, 1);//remove element from array
  //  }
  //}

  sendKPIRelease(item: any) {
    item = this.kpiRelease_data.filter(e => e.kpiUno == item.kpiUno)[0];
    if (item['level1Approver'] == null ||
      item['level1Approver'] == '' ||
      item['level2Approver'] == null ||
      item['level2Approver'] == '' ||
      item['level3Approver'] == null ||
      item['level3Approver'] == '' ||
      item['dataOwnerName'] == null ||
      item['dataOwnerName'] == '' ||
      ((item['slaRuleUno'] == "1" || item['slaRuleUno'] == "2") && (item['targetValue'] == '0'))
    ) { } else {
      this.objkpiRelease = new kpiRelease();
      let objKR = new kpiRelease();
      let objitem: any = item;
      objKR = this.kpiRelease_data.filter(e => e.kpiUno == item.kpiUno)[0];
      objKR.tenantUno = this.tenantUno;
      objKR.dataOwnerUno = item.dataOwnerUno;
      this.objkpiRelease.objkpiRelease.push(objKR);
      this.AddKPIRelease();
    }
  }

  sendKPIReset(objSelected: any) {

    this.objkpiRelease = new kpiRelease();
    let objKR = new kpiRelease();
    let objitem: any = objSelected;
    objKR = objitem;
    objKR.tenantUno = this.tenantUno;
    this.objkpiRelease.dataOwnerActionByUno = this.utilityService.isNumericNull(objitem['dataOwnerActionByUno']);
    this.objkpiRelease.level1Approved = this.utilityService.isNumericNull(objitem['level1Approved']);
    this.objkpiRelease.level2Approved = this.utilityService.isNumericNull(objitem['level2Approved']);
    this.objkpiRelease.level3Approved = this.utilityService.isNumericNull(objitem['level3Approved']);

    this.objkpiRelease.objkpiRelease.push(objKR);
    this.AddKPIReset();

  }
  //view KPI Values
  viewKPI(kpiUno: any) {

    this.loadKPICodeDetails(kpiUno);
    this.kpiUnoSelected = kpiUno;
    // this.loadKPIRelease(5);
    this.loadKPIWorkflow(true);
    this.loadKPITargetHistory();
    return false;

  }
  //Add KPI Release
  AddKPIRelease() {
    
    let objitem: any = this.objkpiRelease;
    if (this.objkpiRelease.objkpiRelease.length <= 0) {
      //Swal.fire('Error', 'KPI is not selected ', 'warning');
      this.toaster.show('warning', 'Warning', 'KPI is not selected', 3000);
    }
    else {

      Swal.fire({
        title: 'Release',
        text: 'Please Confirm to Release the KPI',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.objkpiRelease.userUno = this.login_UserID;
          this.objkpiRelease.tenantUno = this.tenantUno;
          this.restApi.addKpiRelease(this.objkpiRelease)
            .subscribe(data => {

              if (data != null && data != undefined && data != '') {
                //Swal.fire('Error', 'Something went wrong', 'error')
                this.toaster.show('error', 'Error', 'Something went wrong');
              }
              else {
                //Swal.fire({
                //  type: 'success',
                //  title: 'KPI Released Successfully',
                //  showConfirmButton: false,
                //  timer: 1500
                //})

                this.toaster.show('success', 'Success', 'KPI Released Successfully');
                this.isRowSelected = false;
                this.loading = true;
                this.frequencyUno = 3;
                this.loadKPIRelease(2);
                this.loadKPIRelease_Count(2)
              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });

          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      })




    }
    return false;

  }
  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);
   
    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  //Add KPI Reset

  AddKPIReset() {

    let data: any = this.objkpiRelease;
    
    this.resetType_txt = '';
    if (this.objkpiRelease.objkpiRelease.length <= 0) {
      //Swal.fire('Error', 'KPI is not selected ', 'warning');
      this.toaster.show('warning', 'Warning', 'KPI is not selected', 3000);
    }
    else {

      if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno == 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' }
        ];
      }
      if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' }
        ];
      }
      if (data.level1Approved == 1 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' },
          { resettypeCode: 3, resettypeName: 'Pending for Approval - 1' }
        ];
      }
      if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' },
          { resettypeCode: 3, resettypeName: 'Pending for Approval - 1' },
          { resettypeCode: 4, resettypeName: 'Pending for Approval - 2' }
        ];
      }
      if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 1 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' },
          { resettypeCode: 3, resettypeName: 'Pending for Approval - 1' },
          { resettypeCode: 4, resettypeName: 'Pending for Approval - 2' },
          { resettypeCode: 5, resettypeName: 'Pending for Approval - 3' }
        ];
      }
      this.modalRef = this.modalService.show(
        this.ResetDialog,
        Object.assign({}, {
          class: 'gray modal-lg',
          backdrop: true,
          keyboard: true,
          focus: true,
          show: false,
          ignoreBackdropClick: true,
          animated: true
        })
      );
      this.isResetTypeErr = false;
      this.isCommentErr = false;

    }
    return true;

  }
  //KPI Reset value submition
  AddKPIResetFormSubmit() {
    
    this.objkpiRelease.userUno = this.login_UserID;
    this.objkpiRelease.resetComment = this.resetComment;
    this.objkpiRelease.resetType = this.resetType_txt;

    if (this.isResetType) {
      if (this.resetType_txt == '') {
      //  Swal.fire('Error', 'Please select reset type', 'error')
        this.toaster.show('error', 'Error', 'Please enter comment');
        this.isResetTypeErr = true;
        return false;
      }
      if (this.resetComment == '') {
       // Swal.fire('Error', 'Please enter comment', 'error')
        this.toaster.show('error', 'Error', 'Please enter comment');
        this.isCommentErr = true;
        return false;
      }
    }
    else {

      if (this.resetComment == '') {
      //  Swal.fire('Error', 'Please enter comment', 'error')
        this.toaster.show('error', 'Error', 'Please enter comment');
        this.isCommentErr = true;
        return false;
      }
    }
    /*
    Swal.fire({
      title: 'Reset',
      text: 'Please Confirm to Reset the KPI',
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        
      
        this.restApi.addKpiReset(this.objkpiRelease)
          .subscribe(data => {

            if (data != null && data != undefined && data != '') {
              Swal.fire('Error', 'Something went wrong', 'error')
            }
            else {
              Swal.fire({
                type: 'success',
                title: 'KPI Resetted Successfully',
                showConfirmButton: false,
                timer: 1500
              })
              this.loadKPIRelease(4);
            }


            this.spinner.hide();
          },
            (error) => {
              //Called when error
              this.spinner.hide();
            }
          ).add(() => {
            //Called when operation is complete (both success and error)
            this.spinner.hide();
            this.resetComment = '';
            this.resetType_txt = '';
          });
        return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        return;
      }
    })

    */


    this.modalRef.hide()
  }

  //Get KPI History
  loadKPIViewHistory(kpiUno: number, isStart) {
    this.spinner.show();
    let inpValue = new kpiViewHistory();
    inpValue.kpiUno = kpiUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;;
    this.historyStartIndex = (this.historyStartIndex == undefined || this.historyStartIndex < 1 || isStart) ? 1 : this.historyStartIndex;
    inpValue.startIndex = this.historyStartIndex;
    inpValue.maxCount = this.historyMaxCount;

    this.restApi.getkpiViewHistory(inpValue)
      .subscribe(data => {

        let objData: any = data;

        if (this.historyStartIndex == 1) {
          this.kpiViewHistory_data = [];
          this.kpiViewHistory_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewHistory_data.push(objData[i]);
          }
        }
        //if the result set is lessthen 10 then disable the load more icon
        this.historydisableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.historyStartIndex = this.historyStartIndex + 1;
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get KPI Code Details
  loadKPICodeDetails(kpiTrnUno: number) {

    this.spinner.show();
    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = kpiTrnUno;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKPIs(inpValue)
      .subscribe(data => {

        this.kpiCodeDetail = data[0];
        this.loadKPIViewHistory(kpiTrnUno, true);
       
        this.modalRef = this.modalService.show(
          this.KPIViewDialog,
          Object.assign({}, {
            class: 'gray modal-lg',
            backdrop: true,
            keyboard: true,
            focus: true,
            show: false,
            ignoreBackdropClick: true,
            animated: true
          })
        );
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get KPI View KPI Workflow
  loadKPIWorkflow(isStart) {

    this.spinner.show();
    let inpValue = new kpiViewWorkFlow();
    inpValue.kpiTrnUno = 0;
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.kpiUnoSelected;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.workflowStartIndex = (this.workflowStartIndex == undefined || this.workflowStartIndex < 1 || isStart) ? 1 : this.workflowStartIndex;
    inpValue.startIndex = this.workflowStartIndex;
    inpValue.maxCount = this.workflowMaxCount;

    this.restApi.getInddividualKpiViewKPIWorkflow(inpValue)
      .subscribe(data => {

        let objData: any = data;

        if (this.workflowStartIndex == 1) {
          this.kpiViewWorkflow_data = [];
          this.kpiViewWorkflow_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewWorkflow_data.push(objData[i]);
          }
        }
        //if the result set is lessthen 10 then disable the load more icon
        this.workflowdisableMore = (objData.length >= 300) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.workflowStartIndex = this.workflowStartIndex + 1;
        }
        //setTimeout(() => { this.groupWorkflowOptions = { columns: ['kpiYearName', 'kpiQuarterName'] }; }, 100);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  //Get KPI View KPI Workflow
  loadKPITargetHistory() {

    this.spinner.show();
    let inpValue = new kpiViewWorkFlow();
    inpValue.kpiTrnUno = 0;
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.kpiUnoSelected;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKPITargetValueHistory(inpValue)
      .subscribe(data => {

        this.kpiTargetHistory_data = data;
        //setTimeout(() => { this.groupWorkflowOptions = { columns: ['kpiYearName', 'kpiQuarterName'] }; }, 100);
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }



  onchangeSLA(e) {

    //alert(e.itemData.slaUno);
    this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();

  }

  drawertoggle() {

    this.isToggle = (this.isToggle) ? false : true;
  }

  //Events

  onchangeYear(e) {

    this.yearUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeQuarter(e) {
    
    this.quarterUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeDivision(e) {
    this.divisionUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0 && e[0].value!='All') ? e[0].value : 0;
    this.onSelectedTab();
  }

  onchangeResetType(e) {

    this.resetType_txt = (e && e.length > 0 && e.itemData.resettypeName == 'All') ? '' : e[0].resettypeName;
    this.isResetTypeErr = false;
    // this.onSelectedTab();
  }
  onSelectedTab() {
    if (this.isFirstLoaded) {
      if (this.selectedTab == 'Release') {
        this.loadKPIRelease(2); //by filter
        this.loadKPIRelease_Count(2);

      }
      else if (this.selectedTab == 'Reset') {
        this.loadKPIRelease(4); //by filter
      }
    }

  }

  onLinkClick(event: MatTabChangeEvent) {
    this.objkpiRelease = new kpiRelease();
    this.selectedTab = (event.index == 0) ? "Release" : "Reset";

    if (this.selectedTab == 'Release') {
      this.loadKPIRelease(2); //All
      this.loadKPIRelease_Count(2);
    }
    else if (this.selectedTab == 'Reset') {
      this.loadKPIRelease(4); //All
    }
  }



  KpiTargetUpdate(objdata: any) {

    this.kpiTargetForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
    
    this.kpinameSelected = objdata.kpiNameEn;
    this.selected_schedule = objdata.scheduleUno;
    this.selected_kpiUno = (objdata.kpiUno == null || objdata.kpiUno == '') ? 0 : objdata.kpiUno;
    
    if (this.selected_kpiUno > 0) {
      this.addItem_kpiTarget(this.selected_kpiUno, objdata.scheduleUno);

    }

  }

  createyearItem_kpiTarget(objkpitarget: kpitarget): FormGroup {
    
    return this.formBuilder.group({
      kpiUno: objkpitarget.kpiUno,
      kpiYear: objkpitarget.kpiYear,
      kpiYear_Text: objkpitarget.kpiYear_Text,
      frequency: objkpitarget.frequency,
      kpitarget1: objkpitarget.kpitarget1,
      kpitarget2: objkpitarget.kpitarget2,
      kpitarget3: objkpitarget.kpitarget3,
      kpitarget4: objkpitarget.kpitarget4,
      kpitarget5: objkpitarget.kpitarget5,
      kpitarget6: objkpitarget.kpitarget6,
      kpitarget7: objkpitarget.kpitarget7,
      kpitarget8: objkpitarget.kpitarget8,
      kpitarget9: objkpitarget.kpitarget9,
      kpitarget10: objkpitarget.kpitarget10,
      kpitarget11: objkpitarget.kpitarget11,
      kpitarget12: objkpitarget.kpitarget12,
      kpitarget13: objkpitarget.kpitarget13
    });
  }
  addItem_kpiTarget(kpiuno, Frequency): void {
    this.yearsArray = this.kpiTargetForm.get('yearsArray') as FormArray;
    this.spinner.show();
    let inpValue = new kpitarget();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.yearUno;
    inpValue.frequency = Frequency;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getKpiTargets(inpValue)
      .subscribe(kpidata => {
        debugger;
        let objkpidata: any = kpidata;
        if (objkpidata != null && objkpidata.length > 0)
          for (var i = 0; i < 7; i++) {
            
            this.yearsArray.push(this.createyearItem_kpiTarget(kpidata[i]));
          }
        setTimeout(() => {
        this.modalTargetRef = this.modalService.show(
          this.KPITargetUpdate,
          Object.assign({}, {
            class: 'gray modal-xl modal-full',
            backdrop: true,
            keyboard: true,
            focus: true,
            show: false,
            ignoreBackdropClick: true,
            animated: true
          })
        );   }, 10);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }

  saveTarget() {
    if (this.kpiTargetForm.valid) {


      if (!this.AddEditKPITarget(this.kpiTargetForm.value)) {
      //  Swal.fire('Error', 'Something went wrong', 'error');
        this.toaster.show('error', 'Error', 'Something went wrong');
        this.modalTargetRef.hide()
      }
      setTimeout(() => { this.modalTargetRef.hide() }, 10);
    } else {
     // Swal.fire('Error', 'Something went wrong', 'error');
      this.toaster.show('error', 'Error', 'Something went wrong');
      this.modalTargetRef.hide()
    }

  }
  closeTargetDialog() {

    setTimeout(() => { this.modalTargetRef.hide() }, 10);
  }

  AddEditKPITarget(data1: any) {
    if (this.kpiTargetForm == null || this.kpiTargetForm.invalid) {
     // Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong');
      
      return false;
    }

    
    let objKPITarget = new kpitarget();

    objKPITarget.listkpiTarget = data1.yearsArray;
    objKPITarget.userUno = this.login_UserID;
    objKPITarget.kpiYear = this.yearUno;
    objKPITarget.kpiUno = this.selected_kpiUno;
    objKPITarget.condition = 0;//(this.pageAction == "add") ? 0 : 1;
    this.spinner.show();
    this.restApi.addKpiTarget(objKPITarget)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
        //  Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Target Saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'KPI Target Saved.');
          this.modalTargetRef.hide()
          this.loadKPIRelease(2);
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

    return true;

  }

  KpiBandUpdate(objdata: any) {

    this.kpiBandForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
    
    this.kpinameSelected = objdata.kpiNameEn;
    this.selected_schedule = objdata.scheduleUno;
    this.selected_kpiUno = (objdata.kpiUno == null || objdata.kpiUno == '') ? 0 : objdata.kpiUno;
    
    if (this.selected_kpiUno > 0) {

      this.selected_rule = objdata.slaRuleUno;

      this.targetValue_Max = objdata.targetValue;
      this.actualt_target = (objdata.targetValue != null && objdata.targetValue != '') ? parseInt(objdata.targetValue) : 0;
      this.actualt_target = (this.actualt_target >= 100) ? 100 : this.actualt_target;
      this.actualt_target_full = 100;
      if (objdata.scheduleUno == 1) { this.scheduleTypeUno = 19; }
      if (objdata.scheduleUno == 2) { this.scheduleTypeUno = 1; }
      if (objdata.scheduleUno == 3) { this.scheduleTypeUno = 3; }
      if (objdata.scheduleUno == 4) { this.scheduleTypeUno = 7; }
      this.addItem_band(this.selected_kpiUno, objdata.scheduleUno,2);
    }

  }

  createyearItem_band(objkpiband: kpiband): FormGroup {
    
    if (objkpiband.scheduleTypeUno != 0) {
      this.scheduleTypeUno = objkpiband.scheduleTypeUno;
    }
    return this.formBuilder.group({
      kpiUno: objkpiband.kpiUno,
      kpiYear: objkpiband.kpiYear,
      kpiYear_Text: objkpiband.kpiYear_Text,
      rule: objkpiband.rule,
      bandtype: (objkpiband.bandtype == null || objkpiband.bandtype == undefined || objkpiband.bandtype == 0) ? 1 : objkpiband.bandtype,
      band1Condition1: (objkpiband.band1Condition1 == 0) ? 1 : objkpiband.band1Condition1,
      band1Value1: objkpiband.band1Value1,
      band1Condition2: (objkpiband.band1Condition2 == 0) ? 1 : objkpiband.band1Condition2,
      band1Value2: objkpiband.band1Value2,
      band1wellperform: objkpiband.band1wellperform,

      band2Condition1: (objkpiband.band2Condition1 == 0) ? 1 : objkpiband.band2Condition1,
      band2Value1: objkpiband.band2Value1,
      band2Condition2: (objkpiband.band2Condition2 == 0) ? 1 : objkpiband.band2Condition2,
      band2Value2: objkpiband.band2Value2,
      band2wellperform: true,//objkpiband.band2wellperform,

      band3Condition1: (objkpiband.band3Condition1 == 0) ? 1 : objkpiband.band3Condition1,
      band3Value1: objkpiband.band3Value1,
      band3Condition2: (objkpiband.band3Condition2 == 0) ? 1 : objkpiband.band3Condition2,
      band3Value2: objkpiband.band3Value2,
      band3wellperform: objkpiband.band3wellperform,

      band4Condition1: (objkpiband.band4Condition1 == 0) ? 1 : objkpiband.band4Condition1,
      band4Value1: objkpiband.band4Value1,
      band4Condition2: (objkpiband.band4Condition2 == 0) ? 1 : objkpiband.band4Condition2,
      band4Value2: objkpiband.band4Value2,
      band4wellperform: objkpiband.band4wellperform,

      band5Condition1: (objkpiband.band5Condition1 == 0) ? 1 : objkpiband.band5Condition1,
      band5Value1: objkpiband.band5Value1,
      band5Condition2: objkpiband.band5Condition2,
      band5Value2: (objkpiband.band5Condition2 == 0) ? 1 : objkpiband.band5Condition2,
      band5wellperform: objkpiband.band5wellperform,

      scheduleTypeUno: objkpiband.scheduleTypeUno,
    });
  }
  radioChange(eventtypeNumber: any) {
    
    this.scheduleTypeUno = eventtypeNumber;

    this.kpiBandForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });

    this.addItem_band(this.kpiUno_global, this.Frequency_global,1);
    return true;
  }

  createFormGroup(data1: any) {

    this.kpiBandForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
  }

  addItem_band(kpiuno, Frequency, condition: any = null): void {
    this.kpiUno_global = kpiuno;
    this.Frequency_global = Frequency;
    this.yearsArray = this.kpiBandForm.get('yearsArray') as FormArray;
    this.spinner.show();
    let inpValue = new kpiband();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.yearUno;
    inpValue.defaultYear = this.yearUno;
    inpValue.defaultQuater = this.currentQuarter;
    inpValue.defaultMonth = this.currentMonth;
    inpValue.defaultSemiYear = this.currentHalf;
    inpValue.rule = Frequency;
    inpValue.itemUno = 0;
    inpValue.condition = (condition == 4)?condition:2; //!isNullOrUndefined(condition) ? condition : 2;
    inpValue.scheduleTypeUno = this.scheduleTypeUno;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getKpiBands(inpValue)

      .subscribe(kpidata => {
        this.createFormGroup(null);
        this.yearsArray = this.kpiBandForm.get('yearsArray') as FormArray;
        for (var i = 0; i < 7; i++) {
          
          this.yearsArray.push(this.createyearItem_band(kpidata[i]));
        }
        this.spinner.hide();
        if (condition == 2) {
          setTimeout(() => {
            this.modalRefBand = this.modalService.show(
              this.KPIBandUpdate,
              Object.assign({}, {
                class: 'gray modal-xl modal-full',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
          }, 10);
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        // this.spinner.hide();
      });


  }
  saveBand() {
    if (this.kpiBandForm.valid) {


      if (!this.AddEditKPIBand(this.kpiBandForm.value)) {
       // Swal.fire('Error', 'Something went wrong', 'error');

        this.toaster.show('error', 'Error', 'Something went wrong');
        this.modalRefBand.hide()
      }
      setTimeout(() => { this.modalRefBand.hide() }, 10);
    } else {
     // Swal.fire('Error', 'Something went wrong', 'error');

      this.toaster.show('error', 'Error', 'Something went wrong');
      this.modalRefBand.hide()
    }

  }
  closeBandDialog() {
    setTimeout(() => { this.modalRefBand.hide() }, 10);
  }
  AddEditKPIBand(data1: any) {
    if (this.kpiBandForm == null || this.kpiBandForm.invalid) {
     // Swal.fire('Error', 'Something went wrong', 'error')

      this.toaster.show('error', 'Error', 'Something went wrong');
      return false;
    }
    if (this.scheduleTypeUno <= 0) {
      //Swal.fire('Error', 'Schedule type option is mandatory', 'error')

      this.toaster.show('error', 'Error', 'Schedule type option is mandatory');
      return false;
    }
    
    //validate the range
    let isError = false;
    for (var i = 0; i < data1.yearsArray.length - 1; i++) {
      if (data1.yearsArray[i].band1Value1 > 0 && data1.yearsArray[i].band2Value1 > 0) {
        if (data1.yearsArray[i].band1Condition1 == 1) {
          if (data1.yearsArray[i].band1Value1 >= data1.yearsArray[i].band2Value1) {
            isError = true;
            data1.yearsArray[i].isError = true;
          }
          else {
            data1.yearsArray[i].isError = false;
          }
        }
        if (data1.yearsArray[i].band1Condition1 == 2) {
          if (data1.yearsArray[i].band1Value1 > data1.yearsArray[i].band2Value1) {
            isError = true;
            data1.yearsArray[i].isError = true;
          }
          else {
            data1.yearsArray[i].isError = false;
          }
        }
      }
    }

    /*  if (isError) {
        Swal.fire('Error', 'Please correct the input value', 'error')
        return false;
      }*/


    let objKPIBand = new kpiband();
    
    objKPIBand.listkpiBand = data1.yearsArray;
    objKPIBand.userUno = this.login_UserID;
    objKPIBand.kpiYear = this.yearUno;
    objKPIBand.defaultYear = this.yearUno;
    objKPIBand.defaultQuater = 1;
    objKPIBand.defaultMonth = 1;
    objKPIBand.defaultSemiYear = 1;
    objKPIBand.kpiUno = this.selected_kpiUno;
    objKPIBand.rule = this.selected_rule;
    objKPIBand.condition = 1;//(this.pageAction == "add") ? 0 : 1;
    
    objKPIBand.scheduleTypeUno = this.scheduleTypeUno;
    this.restApi.addKpiBand(objKPIBand)
      .subscribe(data => {
        

        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error')
          this.modalRefBand.hide();
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Band saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.modalRefBand.hide();
          this.toaster.show('success', 'Success', 'KPI Band saved.');
          this.loadKPIRelease(2);
        }


        this.spinner.hide();
        return true;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          return true;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
        return true;
      });
    return true;

  }

  getConditions() {
    this.condition1_data = [
      { text: '>', value: 1 },
      { text: '>=', value: 2 },
      { text: '=', value: 3 },
      { text: '<', value: 4 },
      { text: '<=', value: 5 }



    ];
    this.condition2_data = [

      { text: '<', value: 4 },
      { text: '<=', value: 5 }

    ];
  }


  getTypes() {
    this.type_data = [
      { text: '#', value: 1 },
      { text: '%', value: 2 }

    ];
  }



  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }


  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady1(angularGrid: AngularGridInstance) {
    
    let temp = this;
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
    let parent = document.getElementsByClassName('ui-widget-content');
    document.querySelectorAll(".ui-widget-content > .slick-cell-checkboxsel >input").forEach(item => { item.parentElement.parentElement.classList.add('selectableRow') })

    
   
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(ticket =>
        ticket.kpiCode && ticket.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (ticket.kpiNameEn && ticket.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.slaNameEn && ticket.slaNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.period && ticket.period.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.dataOwnerName && ticket.dataOwnerName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.slaRuleName && ticket.slaRuleName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.targetValue && ticket.targetValue.toString().includes(this.searchText.toLowerCase()))
        || (ticket.kpiRule && ticket.kpiRule.toLowerCase().includes(this.searchText.toLowerCase()))
        );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {

    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'slaName', name: 'SLA', field: 'slaName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaName', 'slaName'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'period', name: 'Period', field: 'period', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'period', 'period'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'dataOwnerName', name: 'Owner', field: 'dataOwnerName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'dataOwnerName', 'dataOwnerName'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaRuleName', 'slaRuleName'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'targetValue', name: 'Target', field: 'targetValue', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
          model: Filters.multipleSelect,
        },
        formatter: (row, cell, val, columnDef, dataContext) => {
          if (dataContext.slaRuleUno != 4)
            return dataContext.targetValue;
          else
            return 'Pass';
        }
      },
      {
        id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'rowType', name: 'Row Type', field: 'rowType',  type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'rowType', 'rowType'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'Release-row', titleKey: 'Release_ROW', positionOrder: 62, title: 'Release KPI',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.permision_release && data.rowType == 'Ready')
                  return true;
                else return false;
              },
              iconCssClass: 'fa fa-send-o fa-lg ', cssClass: 'blue ', textCssClass: 'bold',
              action: (e, args) => {
                this.sendKPIRelease(args.dataContext)

              }
            },

            {
              command: 'Target-row', titleKey: 'Target_ROW', positionOrder: 62, title: 'KPI Target',
              iconCssClass: 'fa fa-long-arrow-up fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if ((data.slaRuleUno == 1 || data.slaRuleUno == 2) && (data.rowType == 'T' || data.rowType == 'UT' || data.rowType == 'UTB' || data.rowType == 'TB'))
                  return true;
                else return false;
              },
              action: (e, args) => {
                this.KpiTargetUpdate(args.dataContext);
              }
            },
            {
              command: 'Band-row', titleKey: 'Band_ROW', positionOrder: 64, title: 'KPI Band',
              iconCssClass: 'fa fa-stack-exchange fa-lg ', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (data.slaRuleUno == 1 && ((data.rowType == 'B' || data.rowType == 'TB' || data.rowType == 'UTB' || data.rowType == 'TB')))
                  return true;
                else return false;
              },
              action: (e, args) => {
                this.KpiBandUpdate(args.dataContext);
              }
            },
          


            {
              command: 'info-row', titleKey: 'info_ROW', positionOrder: 67, title: 'KPI Info',
              iconCssClass: 'fa fa-lg fa-info-circle  ', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let data = args.dataContext;
                this.viewKPIHistoryAll(data.kpiUno, data.kpiName);
              },

            },


          ],
        }
      }
    ]


  }

  AddKPIMissingBand() {
    
    let objitem: any = this.objkpiRelease;
    //if (this.objkpiRelease.objkpiRelease.length <= 0) {
    //  //Swal.fire('Error', 'KPI is not selected ', 'warning');
    //  this.toaster.show('warning', 'Warning', 'KPI is not selected', 3000);
    //}
    //else {

      Swal.fire({
        title: 'Reconcile Missing Band',
        text: 'Please Confirm to Reconcile Missing Band',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.objkpiRelease.userUno = this.login_UserID;
          this.objkpiRelease.tenantUno = this.tenantUno;


          this.objkpiRelease.slaUno = (this.slaUno == undefined || this.slaUno == null) ? 0 : this.slaUno;//this.slaUno;
          this.objkpiRelease.slayear = (this.yearUno == 0 || this.yearUno == undefined) ? this.currentYear : this.yearUno;
          this.objkpiRelease.slaquarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? this.currentQuarter : this.quarterUno;
          
          this.objkpiRelease.divisionUno = (this.divisionUno == undefined) ? 0 : this.divisionUno;//this.divisionUno;
          this.objkpiRelease.frequencyUno = (this.frequencyUno == undefined) ? 0 : this.frequencyUno; //this.frequencyUno;
          this.restApi.addKpiMissingBand(this.objkpiRelease)
            .subscribe(data => {

              if (data != null && data != undefined && data != '') {
                //Swal.fire('Error', 'Something went wrong', 'error')
                this.toaster.show('error', 'Error', 'Something went wrong');
              }
              else {
               

                this.toaster.show('success', 'Success', 'Reconcile Missing Band Successfully');
                this.isRowSelected = false; 
                this.loading = true;
                this.frequencyUno = 3;
                this.loadKPIRelease(2);
                this.loadKPIRelease_Count(2)
              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });

          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      })




   // }
    return false;

  }
}


